import { ContractorType } from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  isEditable?: boolean
  disableContractorType?: boolean
  contractorKey?: string
}

export const ContractorTypeSelect = ({
  isEditable,
  disableContractorType,
  contractorKey = 'contractor'
}: Props) => {
  const { t } = useTranslation()

  return (
    <Form.Item name={[contractorKey, 'content_type']}>
      <RadioCardGroup
        disabled={isEditable || disableContractorType}
        options={[
          {
            label: t('person'),
            value: ContractorType.PERSON
          },
          {
            label: t('legal_entity'),
            value: ContractorType.LEGALENTITY
          }
        ]}
      />
    </Form.Item>
  )
}
